<template>
    <base-side-bar>
        <div class="flex flex-col items-center justify-center w-full mx-10">
            <h2
                class="w-4/5 ml-10 font-extrabold leading-9 text-center text-blue-600 sm:text-xl sm:leading-10"
            >
                Moyens commerciaux
            </h2>
            <br />
            <div
                class="flex flex-col items-center justify-center flex-grow w-full"
            >
                 <!--   <wide-card>
                    <base-tips-alert>
                        <p class="my-0 mt-1 text-gray-700">
                            Veillez à montrer votre produit (photos, maquettes,
                            etc...) ou illustrer la présentation de votre
                            prestation (plaquette, films vidéos, etc...).
                        </p>
                    </base-tips-alert>
                </wide-card> -->
                <wide-card title="Stratégie des prix" titleClass="text-center">
                    <!-- <Toggle /> -->
                    <select-menu
                        label="Stratégie des prix"
                        :option="strategiePrix"
                        v-model="moyenCommerciaux.strategiePrix"
                    />
                </wide-card>
                <wide-card
                    title="Stratégie de production"
                    titleClass="text-center"
                >
                    <base-input
                        placeholder="Stratégie de production"
                        v-model="moyenCommerciaux.strategieProduction"
                        :hasError="
                            $v.moyenCommerciaux.strategieProduction.$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Stratégie de production',
                                $v.moyenCommerciaux.strategieProduction
                            )
                        "
                        @blur="$v.moyenCommerciaux.strategieProduction.$touch()"
                    />
                </wide-card>
                <wide-card
                    title="Stratégie de distribution"
                    titleClass="text-center"
                >
                    <select-menu
                        label="Typologie de conquête"
                        :option="choix1"
                        v-model="moyenCommerciaux.choix1"
                    />
                    <select-menu
                        label="Canal Principal"
                        :option="choix2"
                        v-model="moyenCommerciaux.choix2"
                    />
                </wide-card>
                <wide-card
                    title="Stratégie de communication"
                    titleClass="text-center"
                >
                    <div class="text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Objectifs de la communication:</label
                        >
                        <check-box
                            label="Faire connaitre mes produits/services"
                            :selectedValues="
                                moyenCommerciaux.objectifsCommunication
                            "
                            v-on:checked="checkedHandler"
                        />
                        <check-box
                            label="Faire aimer mes produits/services"
                            :selectedValues="
                                moyenCommerciaux.objectifsCommunication
                            "
                            v-on:checked="checkedHandler"
                        />
                        <check-box
                            label="Faire agir les clients potentiels pour acheter"
                            :selectedValues="
                                moyenCommerciaux.objectifsCommunication
                            "
                            v-on:checked="checkedHandler"
                        />
                    </div>
                    <div class="text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Canaux de communication</label
                        >
                        <multiselect
                            v-model="moyenCommerciaux.cannauxComunication"
                            tag-placeholder="Add this as new tag"
                            placeholder="Search or add a tag"
                            label="name"
                            track-by="code"
                            :options="cannauxComunication"
                            :multiple="true"
                            :taggable="true"
                            @tag="addTag"
                        ></multiselect>
                    </div>
                    <base-number-input
                        label="Budget de communication (HT)"
                        :isCurrency="true"
                        v-model="moyenCommerciaux.budgetCommunication"
                        :hasError="
                            $v.moyenCommerciaux.budgetCommunication.$error
                        "
                        :errorMessage="
                            errorMessage(
                                'Budget de communication',
                                $v.moyenCommerciaux.budgetCommunication
                            )
                        "
                        @blur="$v.moyenCommerciaux.budgetCommunication.$touch()"
                    />
                </wide-card>
                <base-primary-button
                    title="Suivant"
                    @click="addMoyenCommerciaux"
                />
            </div>
        </div>
    </base-side-bar>
</template>

<script>
import WideCard from "../../../components/cards/wideCard";
import SelectMenu from "../../../components/forms/select/selectMenu";
import CheckBox from "../../../components/forms/Toggles/CheckBox";
import { mapState } from "vuex";
import {
    required,
    minLength,
    maxLength,
    decimal,
    minValue
} from "vuelidate/lib/validators";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        WideCard,
        SelectMenu,
        CheckBox
    },

    mixins: [errorMessage, scrollToError],

    validations: {
        moyenCommerciaux: {
            strategieProduction: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(200)
            },
            choix1: { required },
            choix2: { required },
            budgetCommunication: { decimal, minValue: minValue(0) }
        }
    },
    data() {
        return {
            moyenCommerciaux: {}
        };
    },
    computed: {
        ...mapState("forms", {
            strategiePrix: state => state.MoyensCommerciaux.strategiePrix,
            choix1: state => state.MoyensCommerciaux.choix1,
            choix2: state => state.MoyensCommerciaux.choix2,
            cannauxComunication: state =>
                state.MoyensCommerciaux.cannauxComunication
        })
    },

    created() {
        this.moyenCommerciaux = this.$store.getters[
            "EtudeDeMarche/getMoyenCommerciaux"
        ];

        this.$store.dispatch("forms/showSection", "Étude de marché");
        this.$store.dispatch("forms/stepFocus", "Moyens Commerciaux");
    },

    methods: {
        checkedHandler(payload) {
            if (
                this.moyenCommerciaux.objectifsCommunication.includes(payload)
            ) {
                this.moyenCommerciaux.objectifsCommunication.splice(
                    this.moyenCommerciaux.objectifsCommunication.indexOf(
                        payload
                    ),
                    1
                );
            } else {
                this.moyenCommerciaux.objectifsCommunication.push(payload);
            }
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code:
                    newTag.substring(0, 2) +
                    Math.floor(Math.random() * 10000000)
            };
            this.moyenCommerciaux.cannauxComunication.push(tag);
        },
        addMoyenCommerciaux() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "EtudeDeMarche/addMoyenCommerciaux",
                    this.moyenCommerciaux
                );
                this.$store.dispatch("EtudeDeMarche/SaveMoyenComm");
                this.$store.dispatch(
                    "forms/subStepComplete",
                    "Moyens Commerciaux"
                );
                this.$router.push({
                    name: "success_message2",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        }
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__tag {
    border-radius: 15px;
}
</style>
